import React from 'react';
import { formatCurrency } from 'utils';
import { TooltipBase } from './';

const TooltipAggregateCostCharges = ({ payload }: any) => {
  const data = payload[0] && payload[0].payload;

  if (!data) return null;

  return (
    <TooltipBase>
      <p>Year: {data.year}</p>
      <p>
        Annualised Contributions:{' '}
        {formatCurrency(data.annualised_contributions)}
      </p>
      <p>
        Annualised Withdrawals: {formatCurrency(data.annualised_withdrawals)}
      </p>
      <p>Product charges: {formatCurrency(data.product_charges)}</p>
      <p>Adviser charges: {formatCurrency(data.advisor_charges)}</p>
      <p>Net value: {formatCurrency(data.net_value)}</p>
    </TooltipBase>
  );
};

export default TooltipAggregateCostCharges;
